<script >
  import axios from "axios";
  export default {
    name: "NcuOvalRedevelopment",
    data() {
      return{
        giving: {}
      }
    },
    methods: {
      getFundsPaid(){
        axios.get("https://give.ncu.edu.jm/api/data/GetDonationDepData?departmentId=21051",
            {})
            .then(r => {
              console.log(r.data)
              this.giving = r.data
            })
      }
    },
    mounted() {
      this.getFundsPaid()
    }
  }


</script>

<template>
  <div>
    <div>
      <div style="background-color: rgba(51, 51, 51, 0.9)">
        <div class=" ">
          <div class="uk-child-width-1-1@m" uk-grid >
            <div style="padding: 0px !important;">
              <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slideshow="ratio: 7:2; animation: push">
                <ul class="uk-slideshow-items">
                  <li>
                    <img src="/ncu_oval.jpg" alt="" uk-cover>
                    <div class="uk-overlay uk-overlay-primary  uk-position-cover" style="background: rgba(34,34,34,.5)">
                      <div class="text_place" style="">
                        <div class="uk-container ">
                          <h1  class="uk-heading-medium  uk-light">NCU Oval Redevelopment </h1>
                          <!--<p class="uk-margin-remove">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>-->
                        </div>
                      </div>
                    </div>
                  </li>

                </ul>

                <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
                <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>

              </div>
            </div>
            <!---->

          </div>
          <!--<div >
              <div class="uk-align-center ">
                  &lt;!&ndash;<h2 class="uk-heading-small uk-text-center" style="font-family: 'Nanum Gothic', sans-serif;">
                      <span class="half-a-border-on-top ">Alumni </span>
                  </h2>&ndash;&gt;

              </div>
          </div>-->
        </div>

      </div>

    </div>
    <div class="uk-padding">
      <div class="uk-container">
        <div class="uk-child-width-1-2@m" uk-grid>
          <div>

            <p>
              The mission is to make the Ncu Oval into a prominent center for sporting activities in Manchester and surrounding parishes.
            </p>
            <p>The NCU Oval as a center will be made to host events in the nights by setting up proper lighting that will rival the National Stadium in quality.</p>
            <p>The design will allow upon completion the hosting of:</p>
            <ul class="uk-list uk-list-bullet">
              <li>Football</li>
              <li>Cricket</li>
              <li>Track & Field</li>
            </ul>
            <p>The oval in the future will also allow for the building of stands for well wishers to cheer while enjoying different sporting activities.</p>

            <p class="uk-text-bold">We need your help because together any vision can be achieved!</p>


          </div>
          <div >
            <div class="uk-text-center">
              <h1 >
                <span style="font-size: 16px; color: #42b983">We are aiming to raise</span><br>
                20, 000 USD</h1>
            </div>
            <div v-if="Object.entries(this.giving).length !== 0">
              <div>
                <div class="uk-flex" v-for="item in this.giving.Amount">
                  <label for="file">{{ item.Currency }}</label>
                  <progress id="file" :max="item.Currency === 'USD' ? 20000: 1000000" :value="item.Total === null ? 0 : item.Total"
                    style="width: 100%; margin-top: -5px; margin-left: 15px; height: 30px"> 32% </progress>
                  <div style="margin-right: 15px"></div>
                  <div></div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
      <div>
        <a href="https://give.ncu.edu.jm/Donate/Iframe?code=21051" target="_blank" class="uk-button uk-button-primary uk-width-1-1">
          Donate here
          <span uk-icon="arrow-right" style="margin-right: 15px"></span>
        </a>
      </div>
    </div>

  </div>
</template>

<style scoped>
.half-a-border-on-top {
  border-bottom: 2px solid gold;
  position: relative;
  color: #033860 ;

}
.half-a-border-on-top:after {
  padding-top: 10px;
  content: "";
  width:50%;
  height: 1px;/* slight higher to work around rounding errors(?) on some zoom levels in some browsers. */

  position: absolute;
  right:0;
  top:-2px;
}
h1{

  font-style: normal;
}
h1{
  font-size: 1.5em !important;
}
.text_place{
  margin-top: 5% !important;
}
@media screen and (min-width:600px){

  .text_place{
    margin-top: 19% !important;
  }
}
@media screen and (min-width:900px){
  h1{
    font-size: 48px !important;
  }
  .text_place{
    margin-top: 20% !important;
  }
}
</style>